import React , {useRef} from "react";
//rtl
import {
    I18nManager,
    BackHandler,
    Alert,
    StyleSheet,
    View,
    ScrollView,
    Dimensions,
    Text,
    StatusBar,
    Image,
    Button,
    TouchableOpacity
} from 'react-native';
import { RFPercentage, RFValue } from "react-native-responsive-fontsize";


import { Feather } from '@expo/vector-icons';





import AsyncStorage from '@react-native-async-storage/async-storage';
import {useFocusEffect, useNavigationState} from "@react-navigation/native";


const Welcome =({navigation})=> {





    let [online,setOnline] = React.useState(true);
    let [checkStorage,setCheckStorage] = React.useState(false);


    let [focused,setFocused] = React.useState(true);

    useFocusEffect(
        React.useCallback(()=>{
            setFocused(true);
            return ()=>{
                setFocused(false);
            }
        },[])
    );
    if(!focused){
        return (<></>);
    }


    React.useEffect(  ()=>{
        // const WelcomeSeen = await AsyncStorage.getItem('WelcomeSeen');
        setCheckStorage(true);
        // if(WelcomeSeen && state.isConnected) {
        //     navigation.reset({
        //         index: 0,
        //         routes: [{ name: "Home" }],
        //     });
        //
        //     // navigation.push('Home');
        // }else{
        //
        // }
    },[]);



    const scrollRef = useRef();
    let windowsizewidth = Dimensions.get('window').width;



    const goHome = async ()=>{
        await AsyncStorage.setItem('WelcomeSeen', '1');
        navigation.reset({
            index: 0,
            routes: [{ name: "Home" }],
        });
    };


    return (
        <View>
            <Text>123</Text>
        </View>


    );
}
const styles = StyleSheet.create({

    bx : {
        flex : 1,
        flexGrow  : 1,
        borderColor : '#8e2de2',
        borderWidth : 1,
        borderTopLeftRadius : 35,
        borderTopRightRadius : 45,
        // backgroundColor : 'red',

        shadowColor: 'red',
        shadowRadius: 100,
        shadowOpacity: 1,
    },

    csbtn : {
        width : "30%",
        backgroundColor : '#8e2de2',
        borderRadius : 10,
        minHeight : RFValue(30),
        justifyContent: "center",
        alignItems: "center",
        margin : RFValue(20),
        alignSelf : 'flex-end'

    },
    btntxt : {
        fontFamily : 'novaria',
        textAlign:'center',

        fontSize:RFValue(15),
        color : '#FFF'
    },

    netbox : {
        flexGrow : 1,
        justifyContent : "center",
        alignItems : 'center',
    },
    nettext : {
        fontFamily : 'iransansdn',
        textAlign:'center',
        marginVertical:RFValue(25),
        fontSize:RFValue(15),
        color : '#555'
    },

    container: {
        flex: 1,
        paddingTop: StatusBar.currentHeight,
    },
    scrollView: {
        backgroundColor: 'green',
        marginHorizontal: 0,
        flex:1,

    },
    items : {
        display:"flex",
        flexDirection:'column',
        // width:'100%',
        backgroundColor:'red',
    },
    header : {
        fontFamily : 'novaria',
        // fontWeight : 'bold',
        textAlign:'center',
        padding:RFValue(25),
        fontSize:RFValue(32),

    },
    text : {
        fontFamily : 'novaria',
        textAlign:"justify",
        flexGrow:1,
        paddingTop:RFValue(20),
        paddingHorizontal:RFValue(35),
        fontSize : RFValue(17),
        lineHeight : RFValue(25),



    },
    txtbtn : {
        color : 'white',
        fontFamily:'iransansdn',
        fontSize:15,

    },
    btn : {
        width : Dimensions.get('window').width / 3,
        // alignSelf : "flex-end",
        marginTop:RFValue(30),
        marginLeft: Dimensions.get('window').width / 2,
        marginBottom: RFValue(60),



    },
    box : {
        width : Dimensions.get('window').width ,
        height: Dimensions.get('window').height,
        flex:1,
        flexDirection:'column',
        justifyContent: "flex-start",
        backgroundColor: 'white'
    },
    img:{
        backgroundColor:'gray',
        width : Dimensions.get('window').width ,
        height: Dimensions.get('window').height / 2.1,
        marginBottom : RFValue(18),
    }
})
export default Welcome;
